import React, { memo } from 'react'
import { StatefulTooltip } from 'baseui/tooltip'
import Classnames from 'classnames'

// recoil
import { useRecoilValue, useRecoilState } from 'recoil'
import { isBuilder, screen, screenOpen } from '@/store/builder/store'
import { opTitle } from '@/utils/store/onepager_template'

function HeroTitle({ headerLayout, getDesign }) {
  // const [title] = useAtom(opTitle)
  const title = useRecoilValue(opTitle)
  const builder = useRecoilValue(isBuilder)
  const [getSreen, setScreen] = useRecoilState(screen)
  const [getScreenOpen, setScreenOpen] = useRecoilState(screenOpen)

  const handleCopyClick = () => {
    setScreen('copy')
    setScreenOpen(true)
  }

  return (
    <>
      {/* if builder add tool tip */}

      {builder && (
        <StatefulTooltip
          content={() => 'Edit Title'}
          showArrow
          placement="left"
        >
          <h1
            onClick={handleCopyClick}
            className={Classnames(
              'heroTitle text-center  text-4xl md:text-7xl leading-tight cursor-pointer hover:opacity-50',
              {
                'md:text-left': headerLayout == 'default' || !headerLayout,
                'md:text-center md:px-20': headerLayout == 'center',
              }
            )}
            style={{
              fontSize: getDesign.headline_text_size
                ? getDesign.headline_text_size + 'px'
                : 'auto',
              lineHeight: getDesign.headline_lineheight
                ? getDesign.headline_lineheight + 'px'
                : 'auto',
            }}
          >
            <div
              dangerouslySetInnerHTML={{
                __html:
                  title ||
                  '<div style="background: rgba(255,255,255,1);color: #000;font-size: 17px;display: inline-block;border-radius: 5px;padding: 15px;font-weight: 200 !important;margin-top: 10px;float:left;">Title has not been set, click to edit.</div><br style="clear: all" />',
              }}
            />
          </h1>
        </StatefulTooltip>
      )}

      {/* not in builder */}

      {!builder && (
        <h1
          className={Classnames(
            'heroTitle text-center  text-4xl md:text-7xl leading-tight',
            {
              'md:text-left': headerLayout == 'default' || !headerLayout,
              'md:text-center md:px-20': headerLayout == 'center',
            }
          )}
          style={{
            fontSize: getDesign.headline_text_size
              ? getDesign.headline_text_size + 'px'
              : 'auto',
            lineHeight: getDesign.headline_lineheight
              ? getDesign.headline_lineheight + 'px'
              : 'auto',
          }}
        >
          {title}
        </h1>
      )}
    </>
  )
}

export default memo(HeroTitle)
// export default HeroTitle
